if (!customElements.get('assortment-interact')) {
    class Assortment extends HTMLElement {

        /**
         * 
         */
        constructor() {
            super();
            this.user = window.customer.currentUserNumber;
            this.active = this.dataset.active == 'true';
            this.variantId = this.dataset.variantId;
            this.customerId = window.customer.id;
            this.userName = window.customer.userName;
            this.handle = this.dataset.handle;
            this.productId = this.dataset.productId;
            this.tags = [];
            this.current_kio = false;

             // ✅ Bind event handlers once here
            this._handleClick = this.handleClick.bind(this);
            this._handleAssortmentAdded = this.handleAssortmentAdded.bind(this);
            this._handleAssortmentRemoved = this.handleAssortmentRemoved.bind(this);
            this._toggleTagConnection = this.toggleTagConnection.bind(this);
            this._handleTagAdded = this.handleTagAdded.bind(this);
            this._handleTagRemoved = this.handleTagRemoved.bind(this);
        }

        connectedCallback() {
            try {
                this.tags = JSON.parse(this.querySelector('[data-custom-tags]').innerText);
                const currentKioInnerText = this.querySelector('[data-current-kio]').innerText.trim();
                if (currentKioInnerText != '') {
                    this.current_kio = JSON.parse(currentKioInnerText);
                }
            } catch (e) {
                console.log(e);
            }

            // ✅ Use the bound versions
            this.querySelector('button')?.addEventListener('click', this._handleClick);
            document.addEventListener('on:product-assortment:add', this._handleAssortmentAdded);
            document.addEventListener('on:product-assortment:remove', this._handleAssortmentRemoved);
            document.addEventListener('on:tag:added', this._handleTagAdded);
            document.addEventListener('on:tag:removed', this._handleTagRemoved);
            this.querySelectorAll('li').forEach(item => item.addEventListener('click', this._toggleTagConnection));
        }

        disconnectedCallback() {
            // ✅ Remove exactly the same references
            this.querySelector('button')?.removeEventListener('click', this._handleClick);
            document.removeEventListener('on:product-assortment:add', this._handleAssortmentAdded);
            document.removeEventListener('on:product-assortment:remove', this._handleAssortmentRemoved);
            document.removeEventListener('on:tag:added', this._handleTagAdded);
            document.removeEventListener('on:tag:removed', this._handleTagRemoved);
            this.querySelectorAll('li').forEach(item => item.removeEventListener('click', this._toggleTagConnection));
        }

        /**
         * 
         * @param {*} e 
         */
        async handleVariantChange({ detail }) {

            this.variantId = detail.variant.id;

            this.current_kio = false;
            const currentKioInnerText = this.querySelector('[data-current-kio]').innerText.trim();
            if (currentKioInnerText != '') {
                this.current_kio = JSON.parse(currentKioInnerText);
            }

            if (!this.current_kio) {
                return;
            }

            if (window.customer?.currentUserNumber?.startsWith('b2b_')) {
                return;
            }

            const formData = new FormData();
            formData.set('customerId', this.customerId || '');
            formData.set('userNumber', this.user || '');
            formData.set('userName', this.userName || '');
            formData.set('variantId', this.current_kio.variantId);

            await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
                method: 'POST',
                body: formData
            });

            formData.set('variantId', `gid://shopify/ProductVariant/${this.variantId}`);
            await fetch('/apps/stroetmann/api/v1/users/create_kio', {
                method: 'POST',
                body: formData
            });

            this.querySelector('[data-current-kio]').innerText = JSON.stringify({
                handle: this.handle,
                variantId: `gid://shopify/ProductVariant/${this.variantId}`,
                sales: this.current_kio.sales
            })

            return;
        }

        /**
         * 
         * @param {*} param0 
         */
        handleTagAdded({ detail }) {
            const { filter } = detail;
            this.tags.push({
                handles: [],
                name: filter
            });
            const markup = `
                <li class="flex flex-row" data-filter="${filter}" data-included="false" data-count="0">
                    <span data-not-included>
                        <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linejoin="round" aria-hidden="true" focusable="false" role="presentation" class="icon"><path d="M5 19 19 5M5 5l14 14"/></svg>
                    </span>
                    <span data-is-included>
                        <svg style="width:24px;height:24px" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" class="icon"><path fill="currentColor" d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8-1.41-1.42Z"/></svg>
                    </span>
                    <span>${filter.split(':')[0]}</span>
                    <span data-count>0</span>
                </li>`;
            this.querySelector('.assortment-custom-list ul').insertAdjacentHTML('beforeend', markup);
            this.querySelector(`li[data-filter="${filter}"]`).addEventListener('click', this.toggleTagConnection.bind(this));
        }

        /**
         * 
         * @param {*} param0 
         */
        handleTagRemoved({ detail }) {
            const { tag } = detail;
            this.tags = this.tags.filter((currentTag) => currentTag.tag != tag);
            this.querySelector(`li[data-filter="${tag}"]`)?.remove();
        }

        /**
         * 
         * @param {*} param0 
         */
        toggleTagConnection({ target }) {
            const { dataset } = target.closest('li');
            const { filter, included } = dataset;
            included == 'true' ?
                this._handleDisconnectTag(filter) :
                this._handleConnectTag(filter);
        }

        /**
         * 
         * @param {*} target 
         * @returns 
         */
        async _handleConnectTag(tag) {
            await this._handleConnectProduct(tag);
            !this.active ?
                this.handleAddToKio(tag) :
                this._dispatchAdd(tag);
        }

        /**
         * 
         * @param {*} target 
         * @returns 
         */
        async _handleDisconnectTag(tag) {
            await this._handleDisconnectProductFromTag(tag);
            const removeProduct = this.tags.filter((current_tag) => current_tag.name != tag && current_tag.handles.includes(this.handle)).length == 0;
            removeProduct ?
                this.handleRemoveFromKio(tag) :
                this._dispatchRemove(tag);
        }

        /**
         * 
         * @param {*} tag 
         */
        _handleConnectProduct(tag) {
            const { customerId, userName, userNumber } = this.getRequestParams();
            const requestBody = {
                customerId,
                userName,
                userNumber,
                filterName: tag,
                newFilterName: tag,
                filterValue: {
                    handle: this.handle,
                    action: "add"
                }
            };
            return fetch(new URL(`${location.origin}/apps/stroetmann/api/v1/customers/set_assortment`), {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
        }

        /**
         * 
         * @param {*} tag 
         * @returns 
         */
        _handleDisconnectProductFromTag(tag) {
            const { customerId, userName, userNumber } = this.getRequestParams();
            const requestBody = {
                customerId,
                userName,
                userNumber,
                filterName: tag,
                newFilterName: tag,
                filterValue: {
                    handle: this.handle,
                    action: "remove"
                }
            };
            return fetch(new URL(`${location.origin}/apps/stroetmann/api/v1/customers/set_assortment`), {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            });
        }

        /**
         * 
         * @returns 
         */
        getRequestParams() {
            return {
                customerId: window.customer.id,
                userName: window.customer.userName,
                userNumber: window.customer.currentUserNumber,
            };
        };

        /**
         * 
         * @param {*} param0 
         * @returns 
         */
        handleAssortmentAdded({ detail }) {

            const { handle, productId, tag, variantId } = detail;

            if (tag) {
                this.tags = this.tags
                    .map((currentTag) => {
                        if (currentTag.name != tag) {
                            return currentTag;
                        }
                        const element = this.querySelector(`li[data-filter="${currentTag.name}"]`);
                        const count = parseInt(element.dataset.count) + 1;
                        element.dataset.count = count;
                        element.dataset.included = (this.handle == handle).toString();
                        element.querySelector('[data-count]').innerHTML = count;
                        return {
                            ...currentTag,
                            handles: [...currentTag.handles, handle]
                        }
                    });
            }

            if (this.variantId != variantId) {
                return;
            }

            this.querySelector('[data-current-kio]').innerText = JSON.stringify({
                variantId: `gid://shopify/ProductVariant/${this.variantId}`,
                handle: this.handle,
                sales: null
            });

            this.active = true;
            this.dataset.active = this.active.toString();
        }

        /**
         * 
         * @param {*} param0 
         * @returns 
         */
        async handleAssortmentRemoved({ detail }) {

            if (detail.handle != this.handle) {
                return;
            }

            const { handle, productId, tag, variantId } = detail;

            if (tag) {
                this.tags = this.tags
                    .map((currentTag) => {
                        if (currentTag.name != tag) {
                            return currentTag;
                        }
                        const element = this.querySelector(`li[data-filter="${currentTag.name}"]`);
                        const count = parseInt(element.dataset.count) - 1;
                        element.dataset.count = count;
                        element.dataset.included = 'false';
                        element.querySelector('[data-count]').innerHTML = count;
                        return {
                            ...currentTag,
                            handles: currentTag.handles.filter((current_handle) => current_handle != this.handle)
                        }
                    });
            } else {
                const removeFromTags = [];
                this.tags = this.tags
                    .map((tag) => {
                        if (tag.handles.includes(this.handle)) {
                            removeFromTags.push(tag.name);
                        }
                        return {
                            ...tag,
                            handles: tag.handles.filter((current_handle) => current_handle != this.handle)
                        }
                    });
                for await (const tagName of removeFromTags) {
                    await this._handleDisconnectProductFromTag(tagName);
                    const element = this.querySelector(`li[data-filter="${tagName}"]`);
                    const count = parseInt(element.dataset.count) - 1;
                    element.dataset.count = count;
                    element.dataset.included = 'false';
                    element.querySelector('[data-count]').innerHTML = count;
                }
            }
            this._dispatchUpdate();
            if (this.variantId != detail.variantId) {
                return;
            }
            const isActive = this.active && this.tags.filter((tag) => tag.handles.includes(this.handle)).length > 0;
            this.active = isActive;
            this.dataset.active = this.active.toString();
            if (!this.active) {
                this.querySelector('[data-current-kio]').innerText = '';
            }
        }

        /**
         * 
         */
        async handleClick() {
            this.active ?
                this.handleRemoveFromKio() :
                this.handleAddToKio();
        }

        /**
         * 
         * @returns 
         */
        async handleAddToKio(tag = null) {

            if (window.customer?.currentUserNumber?.startsWith('b2b_')) {
                return;
            }

            const currentKioInnerText = this.querySelector('[data-current-kio]').innerText.trim();
            if (currentKioInnerText != '') {
                this.current_kio = JSON.parse(currentKioInnerText);
            }

            const formData = new FormData();
            formData.set('customerId', this.customerId || '');
            formData.set('userNumber', this.user || '');
            formData.set('userName', this.userName || '');

            if (this.current_kio) {
                formData.set('variantId', this.current_kio.variantId);
                await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
                    method: 'POST',
                    body: formData
                });
            }

            let getVariantId = this.getAttribute(`data-variant-id`) || this.variantId;

            formData.set('variantId', `gid://shopify/ProductVariant/${getVariantId}`);

            const kioRequest = await fetch('/apps/stroetmann/api/v1/users/create_kio', {
                method: 'POST',
                body: formData
            });

            if (!kioRequest.ok) {
                return;
            }

            this.querySelector('[data-current-kio]').innerText = JSON.stringify({
                variantId: `gid://shopify/ProductVariant/${this.variantId}`,
                handle: this.handle,
                sales: null
            });
            this._dispatchAdd(tag);
            return kioRequest;
        }

        /**
         * 
         * @returns 
         */
        async handleRemoveFromKio(tag = null) {

            if (window.customer?.currentUserNumber?.startsWith('b2b_')) {
                return;
            }

            const formData = new FormData();
            formData.set('customerId', this.customerId || '');
            formData.set('userNumber', this.user || '');
            formData.set('userName', this.userName || '');
            formData.set('variantId', `gid://shopify/ProductVariant/${this.variantId}`);
            const kioRequest = await fetch('/apps/stroetmann/api/v1/users/delete_kio', {
                method: 'POST',
                body: formData
            });

            if (!kioRequest.ok) {
                return;
            }
            this._dispatchRemove(tag);
            this.querySelector('[data-current-kio]').innerText = '';
            return kioRequest;
        }

        /**
         * 
         * @param {*} tag 
         */
        _dispatchAdd(tag = null) {
            this._dispatch('on:product-assortment:add', tag);
        }

        /**
         * 
         * @param {*} tag 
         */
        _dispatchRemove(tag = null) {
            this._dispatch('on:product-assortment:remove', tag);
        }

        /**
         * 
         * @param {*} tag 
         */
        _dispatchUpdate() {
            document.dispatchEvent(new CustomEvent('on:product-assortment:update', {
                detail: {
                    handle: this.handle,
                    tags: this.tags
                }
            }));
        }

        /**
         * 
         * @param {*} event 
         * @param {*} tag 
         */
        _dispatch(event, tag) {
            document.dispatchEvent(new CustomEvent(event, {
                detail: {
                    handle: this.handle,
                    variantId: this.variantId,
                    productId: this.productId,
                    tag: tag,
                }
            }));


        }

        /**
         * 
         * @param {*} param0 
         * @returns 
         */
        // _update({ detail }) {
        // // if (detail.handle == this.handle) {
        // //     return;
        // // }
        //     this.tags = detail.tags;
        //     this.tags
        //         .forEach((tag) => {
        //             const element = this.querySelector(`li[data-filter="${tag.name}"]`);
        //             if (!element) {
        //                 return;
        //             }

        //             element.dataset.count = tag.handles.filter((handle) => handle.trim() != '').length;
        //             element.dataset.included = tag.handles.includes(this.handle).toString();
        //             element.querySelector('[data-count]').innerHTML = element.dataset.count;
        //         });
        // }
    }

    customElements.define('assortment-interact', Assortment);
}
